import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import ReactPaginate from 'react-paginate';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DialogBox from "../OtherComponents/DialogBox";
import Header from '../Header';
import Footer from '../Footer';
import ViewUserSideBar from './ViewUserSideBar';

import { fetchSingleUserPosts } from '../../utils/UserComponents';
import { getAuthToken } from "../../utils/auth";

const Base_Url = process.env.REACT_APP_BASE_URL;

const UserAllPosts = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [open, setOpen] = useState(false);
    const [postToDelete, setPostToDelete] = useState(null);
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const queryParams = new URLSearchParams(location.search);
    const initialPage = parseInt(queryParams.get('page')) || 1;

    const [limit, setLimit] = useState(5);
    const [page, setPage] = useState(initialPage);
    const [totalPages, setTotalPages] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');

    const role = location?.state?.role || localStorage.getItem('role');

    const updateUrlParams = useCallback(async (newPage, newLimit) => {
        const searchParams = new URLSearchParams(location.search);
        searchParams.set('page', newPage);
        searchParams.set('limit', newLimit);
        navigate({ search: searchParams.toString() });
    }, [location.search, navigate]);

    useEffect(() => {
        const id = location.pathname.split('/').pop();
        setLoading(true);
        fetchSingleUserPosts(id, setPosts, page, limit, setTotalPages, searchQuery);
        updateUrlParams(page, limit);
        setTimeout(() => {
            setLoading(false);
        }, 1000)
    }, [page, searchQuery, limit, location.pathname, updateUrlParams]);


    const handleLimitChange = (e) => {
        const newLimit = parseInt(e.target.value);
        setLimit(newLimit);
        setPage(1);
        updateUrlParams(1, newLimit);
    };


    const handleViewPost = (post) => {
        navigate(`/view/post/${post._id}`);
    };

    const handleDeletePost = async () => {
        try {
            const token = getAuthToken();
            if (token) {
                axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                const res = await axios.post(`${Base_Url}/api/posts/delete-post`, { id: postToDelete._id });
                setTimeout(() => {
                    toast.success(res.data.msg);
                    setOpen(false);
                    const updatedPosts = posts.filter(post => post._id !== postToDelete._id);
                    setPosts(updatedPosts);
                }, 1000);
            }
        } catch (e) {
            toast.error('Server error. Please try again later');
            setOpen(false);
        }
    };

    const handleClose = () => {
        setOpen(false);
    };



    const handlePageChange = (selectedPage) => {
        const newPage = selectedPage.selected + 1; // ReactPaginate uses 0-based indexing
        setPage(newPage);
        updateUrlParams(newPage, limit);
    };


    const handleSearch = (e) => {
        setLoading(true)
        setSearchQuery(e.target.value);
        setPage(1);
        updateUrlParams(1, limit);
    };

    return (
        <>
            <Header />
            <ToastContainer />
            <div className='flex-screen custom_section user-posts'>
                <ViewUserSideBar />
                <div className='aligned-container '>
                <div className="custom_container">
                  

                    <div className="search-container">
                    <div className="topHeading">
                        <h2>Posts</h2>
                    </div>
                        <input
                            type="text"
                            placeholder="Search posts by title"
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                    </div>

                    {loading ? (
                        <div className="container loading-dots">
                            <span>.</span><span>.</span><span>.</span>
                        </div>)
                        :
                        <>
                            {!loading && (posts && posts.length > 0 ? (
                                <div className='post-container'>
                                    {posts.map(post => (
                                        <div className="slide-box post-card" key={post._id}>
                                            <div className='badge-div'>
                                                {Number(post.paidAmount) === Number(post.amount) && (
                                                    <span className="fully-paid-badge">Fully Paid</span>
                                                )}
                                                {Number(post.paidAmount) < Number(post.amount) && (
                                                    <span className="partially-paid-badge">Partially Paid</span>
                                                )}
                                            </div>
                                           
                                            <div class="card-image"> <img src={`${Base_Url}/assets/postThumbnails/${post.attachment}`} alt="" /></div>
                                            <div className="card-content">
                                            <h2 className="slider-title post-title">{post.title}</h2>
                                            <h2 className="slider-amount">${post.amount}</h2>
                                            <p className='description' dangerouslySetInnerHTML={{ __html: post.description }} ></p>

                                            {role === 'admin' && (
                                                <div className='donate-btns'>
                                                <button className='donate-btn' onClick={() => handleViewPost(post)}>View</button>

                                                    <button
                                                        className='donate-btn'
                                                        onClick={() => navigate(`/edit/post/${post._id}`, {
                                                            state: { isEditing: true, post: post }
                                                        })}
                                                    >
                                                        Edit
                                                    </button>
                                                    <button
                                                        className='donate-btn'
                                                        onClick={() => {
                                                            setOpen(true);
                                                            setPostToDelete(post);
                                                        }}
                                                    >
                                                        Delete
                                                    </button>
                                                </div>
                                            )}
                                        </div> </div>
                                    ))}
                                </div>
                            ) : (
                                <div className='post-container'>
                                    No Posts Found
                                </div>
                            ))}

                            {!loading && (
                                <>
                                    <div className='blog-paginate'>
                                        <div className='limit-selection'>
                                            <label htmlFor="limit">Posts per page: </label>
                                            <select id="limit" value={limit} onChange={handleLimitChange}>
                                                <option value={5}>5</option>
                                                <option value={10}>10</option>
                                                <option value={25}>25</option>
                                                <option value={50}>50</option>
                                            </select>
                                        </div>

                                        {posts && posts.length > 0 && totalPages && totalPages > 1 &&
                                            <ReactPaginate
                                                pageCount={totalPages}
                                                onPageChange={handlePageChange}
                                                containerClassName="pagination"
                                                previousLabel={"<"}
                                                nextLabel={">"}
                                                breakLabel={"..."}
                                                pageClassName={"page-item"}
                                                activeClassName={"active"}
                                                marginPagesDisplayed={1}
                                                pageRangeDisplayed={2}
                                                forcePage={page - 1} // Sync with current page
                                            />}
                                    </div>
                                </>
                            )}

                            {open && (
                                <DialogBox
                                    open={open}
                                    handleClose={handleClose}
                                    handleAction={handleDeletePost}
                                    action={postToDelete}
                                    item={'user'}
                                />
                            )}

                        </>}

                </div>
            </div></div>
            <Footer />
        </>
    );
};

export default UserAllPosts;
